import React, { useState, useMemo } from "react";
import { Button, Badge, DataTable, clientSortRows } from "./ui";
import { MDBContainer, MDBCard, MDBCardBody, MDBModal, MDBModalDialog, MDBModalContent, MDBModalHeader, MDBModalTitle, MDBModalBody, MDBModalFooter, MDBInput, MDBRow, MDBCol } from "mdb-react-ui-kit";

function Platforms() {
  const [openModal, setOpenModal] = useState(false);
  const [tableSortColumn, setTableSortColumn] = useState("name");
  const [sortDirection, setSortDirection] = useState("asc");

  const toggleModal = () => {
    setOpenModal(!openModal);
  };

  const platformsData = [
    // Replace with API data
    { id: 1, name: "Platform 1", logo: "logo.png", status: "Active" },
    { id: 2, name: "Platform 2", logo: "logo2.png", status: "Inactive" },
    // ... more platforms
  ];

  const sortedPlatforms = useMemo(
    () =>
      clientSortRows(platformsData, tableSortColumn, sortDirection, (platform, col) => {
        if (col === "status") return (platform.status || "").toLowerCase();
        return (platform[col] || "").toString().toLowerCase();
      }),
    [tableSortColumn, sortDirection]
  );

  const columns = useMemo(
    () => [
      {
        id: "name",
        header: "Platform",
        sortable: true,
        strong: true,
        render: (platform) => platform.name,
      },
      {
        id: "logo",
        header: "Logo",
        render: (platform) => (
          <img
            src={platform.logo}
            alt={platform.name}
            style={{ width: "45px", height: "45px" }}
            className="rounded-circle"
          />
        ),
      },
      {
        id: "status",
        header: "Status",
        sortable: true,
        render: (platform) => (
          <Badge color={platform.status === "Active" ? "success" : "danger"} pill>
            {platform.status}
          </Badge>
        ),
      },
      {
        id: "actions",
        header: "Actions",
        hideable: false,
        render: () => (
          <div onClick={(e) => e.stopPropagation()}>
            <Button color="info" size="sm">
              Edit
            </Button>
          </div>
        ),
      },
    ],
    []
  );

  return (
    <MDBContainer fluid className="p-4 content-area flex-grow-1">
      <h2>Platforms</h2>
      <MDBRow className="mb-4 g-4">
        <MDBCol md="12">
          <MDBCard className="h-100">
            <MDBCardBody className="text-center">
              {platformsData.length === 0 && <p>No Platforms Added</p>}
              <Button onClick={toggleModal}>Add a platform</Button>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      </MDBRow>

      <MDBRow>
        <MDBCol md="12">
          <MDBCard className="content-card">
            <MDBCardBody>
              <DataTable
                tableId="platforms"
                title="Platforms"
                selectionMode="index"
                columns={columns}
                data={sortedPlatforms}
                rowKey="id"
                emptyState="No Platforms Added"
                sort={{
                  column: tableSortColumn,
                  direction: sortDirection,
                  onChange: ({ column, direction }) => {
                    setTableSortColumn(column);
                    setSortDirection(direction);
                  },
                }}
              />
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      </MDBRow>

      {/* Modal for adding new platform */}
      <MDBModal open={openModal} setOpen={setOpenModal} tabIndex="-1">
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Add Platform</MDBModalTitle>
              <Button className="btn-close" onClick={toggleModal}></Button>
            </MDBModalHeader>
            <MDBModalBody>
              <MDBInput className="mb-4" type="text" label="Username" />
              <MDBInput className="mb-4" type="password" label="Password" />
              <MDBInput className="mb-4" type="text" label="Token ID" />
            </MDBModalBody>
            <MDBModalFooter>
              <Button color="secondary" onClick={toggleModal}>
                Close
              </Button>
              <Button>Submit</Button>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </MDBContainer>
  );
}

export default Platforms;
